import script from "./employmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./employmentPage.vue?vue&type=script&setup=true&lang=js"

import "./employmentPage.vue?vue&type=style&index=0&id=d930379e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d930379e"]])

export default __exports__